import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {
      id: null,
      email: null,
      name: null,
      login: false,
      url: null, 
      families: null,
      brands: null
    },
    currencies: {
      currenciesValues: null,
      date: null
    },
    users: [
      {
        id: 1,
        email: "marie.francois@gmail.com",
        name: "Marie François",
        password: "marie.f.12"
      },
      {
        id: 2,
        email: "test@gmail.com",
        name: "John Doe",
        password: "azerty"
      }
    ], 
    queries: []
  },
  getters: {
    getUserId: state => state.user.id,
    getUserEmail: state => state.user.email,
    getUserName: state => state.user.name,
    getUserLogin: state => state.user.login,
    getCurrencies: state => state.currencies,
    checkUser: state => (username, password) => {
      for (let user in state.users) {
        if (username && password && state.users[user].email == username && state.users[user].password == password) {
          return {
            id: state.users[user].id,
            email: state.users[user].email,
            name: state.users[user].name
          }
        }
      }
      return false
    }
  },
  mutations: {
    setCurrencies (state, currencies) {
      Vue.set(state.currencies, 'date', currencies.currenciesData.date)
      Vue.set(state.currencies, 'currenciesValues', currencies.currenciesData.currenciesValues)
    },
    setUserFamilies(state, userFamilies) {
      Vue.set(state.user, 'families', userFamilies)
    },
    setUserBrands(state, userBrands) {
      Vue.set(state.user, 'brands', userBrands)
    },
    setUserName (state, name) {
      Vue.set(state.user, 'name', name)
    },
    setUrl (state, url) {
      Vue.set(state.user, 'url', url )
    },
    setUser (state, user) {
      Vue.set(state.user, 'id', user.id)
      Vue.set(state.user, 'email', user.email)
      Vue.set(state.user, 'name', user.name)
      Vue.set(state.user, 'login', true)
      Vue.set(state.user, 'token', user.token)
    }, 
    addQuery(query) {
      this.state.queries.push(query)
    }
  }
})

export default store
